import { createRouter, createWebHistory } from 'vue-router'
import Overview from './views/Overview.vue'
import Agents from './views/Agents.vue'
import Contacts from './views/Contacts.vue'
import Libraries from './views/Libraries.vue'
import Conversations from './views/Conversations.vue'
import Points from './views/Points.vue'
import PaymentReturn from './views/PaymentReturn.vue'
import Settings from './views/Settings.vue'
import { useAppStore } from './store'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/overview' },
    { path: '/overview', component: Overview, meta: { title: '工作概览', group: '总览' } },
    { path: '/agents', component: Agents, meta: { title: 'AI 客服', group: '业务配置' } },
    { path: '/contacts', component: Contacts, meta: { title: '联系人', group: '业务配置' } },
    { path: '/knowledge', component: Libraries, props: { kind: 'knowledge' }, meta: { title: '知识库', group: '内容管理' } },
    { path: '/scripts', component: Libraries, props: { kind: 'script' }, meta: { title: '话术库', group: '内容管理' } },
    { path: '/memories', component: Libraries, props: { kind: 'memory' }, meta: { title: '记忆', group: '内容管理' } },
    { path: '/conversations', component: Conversations, meta: { title: '对话记录', group: '数据记录' } },
    { path: '/points', component: Points, meta: { title: '点数与用量', group: '数据记录' } },
    { path: '/payments/return', component: PaymentReturn, meta: { title: '支付结果', group: '数据记录' } },
    { path: '/settings', component: Settings, meta: { title: '企业设置', group: '系统' } },
    { path: '/:pathMatch(.*)*', redirect: '/overview' }
  ]
})

function capturePaymentReturn(to: { path: string; query: Record<string, unknown> }) {
  if (to.path !== '/payments/return') return
  const candidate = to.query.out_trade_no ?? to.query.order_id ?? to.query.orderId
  const orderId = Array.isArray(candidate) ? String(candidate[0] ?? '') : String(candidate ?? '')
  if (!/^[A-Za-z0-9_-]{1,64}$/.test(orderId)) return
  sessionStorage.setItem('zhiying-payment-return', JSON.stringify({
    orderId,
    receivedAt: Date.now()
  }))
}

router.beforeEach(async (to) => {
  // Capture the provider return before session validation. If Casdoor asks for a
  // fresh login, the order number survives the round trip in sessionStorage.
  capturePaymentReturn(to)
  const store = useAppStore()
  if (!store.sessionReady) await store.checkSession()
  if (store.authenticated) {
    if (to.path !== '/points' && sessionStorage.getItem('zhiying-payment-return')) return '/points'
    return true
  }
  /* 未登录 → 直接跳 Casdoor 单点登录，不再展示登录门屏。
     sessionError（后端不可用等非 401 错误）时留在页面显示错误与重试；
     10 秒内已自动跳过一次也留在页面，防止 SSO 未接通时无限往返。 */
  const lastAttempt = Number(sessionStorage.getItem('sso-auto-redirect') || 0)
  if (!store.sessionError && Date.now() - lastAttempt > 10000) {
    sessionStorage.setItem('sso-auto-redirect', String(Date.now()))
    store.login()
  }
  return false
})
